import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { exchangeGoogleSession, setToken } from "../lib/api";

// Handles the return from Emergent Google OAuth: the browser lands here at
// {origin}/...#session_id=xxxx. We exchange the one-time session_id on the
// backend, establish the session, then redirect into the app.
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;      // guard against StrictMode double-run
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    // Clear the fragment so the token never lingers in the URL/history.
    window.history.replaceState(null, "", window.location.pathname + window.location.search);

    if (!sessionId) { navigate("/login", { replace: true }); return; }

    exchangeGoogleSession(sessionId)
      .then((data) => {
        setToken(data.token);
        setUser(data.user);
        navigate("/account", { replace: true, state: { user: data.user } });
      })
      .catch(() => {
        navigate("/login", { replace: true, state: { error: "Google sign-in failed. Please try again." } });
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-muted-foreground" data-testid="auth-callback">
      <Loader2 className="h-6 w-6 animate-spin" />
      <p className="mt-3 text-sm">Signing you in…</p>
    </div>
  );
}
